'use client';

import { SelectedPersonalizationKey } from '@libs/algolia';

import { useProductDetails } from '@app/pdp/hooks/useProductDetails';

import ProductVariantRadioFields from './ProductVariantRadioFields';
import ProductVariantColorToggle from './ProductVariantColorToggle';

import './ProductVariant.scss';

export default function ProductVariant() {
    const {
        uniqueVariants: { color: _color, ...filteredVariants },
        availableColors,
        availablePersonalizations: {
            [SelectedPersonalizationKey.THREAD_COLORS]: threadColors,
            ...personalizations
        },
        handleSelectedValue,
    } = useProductDetails();

    const colorValues = {
        ...availableColors,
        [SelectedPersonalizationKey.THREAD_COLORS]: threadColors,
    };

    return (
        <div className="size-variant">
            <ProductVariantRadioFields
                variants={filteredVariants}
                onChange={handleSelectedValue}
            />
            <ProductVariantColorToggle
                variants={colorValues}
                onChange={handleSelectedValue}
            />
            <ProductVariantRadioFields variants={personalizations} />
        </div>
    );
}
